import { createSlice } from '@reduxjs/toolkit'
import socketFactory from '../../utils/socketFactory'

const initialState = {
    connected: false

}



const socketSlice = createSlice({
    name: 'socket',
    initialState,
    reducers: {
        ON_DISCONNECT: (state) => {
            console.log("disconnect slice")
            state.connected = false
        },
        ON_CONNECT: (state) => {
            console.log("connect slice")
            state.connected = true
        },
        ON_TEST: (state, action) => {
            console.log("testResponse action", action.payload.data)
        }
    }
})

export const {
    ON_CONNECT,
    ON_DISCONNECT,
    ON_TEST
} = socketSlice.actions



socketFactory.on('disconnect', ON_DISCONNECT);

socketFactory.on('connect', ON_CONNECT);


socketFactory.on('testResponse', ON_TEST);
socketFactory.on('testResponse', (event) => {console.log("testResponse callback", event.data)});

export const sendTest = socketFactory.emit('test', 'socket/sendTest');



export default socketSlice.reducer